module.exports = __webpack_public_path__ + "static/media/icon_whitelabel.3a67b2ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_whitelabel.png
// module id = 1625
// module chunks = 0